import React from 'react';
import {Row, Col} from 'antd';

class App extends React.Component {
  render() {
    const {
      datas = {key: '', name: '', data: []}, showSubTitle = false
      , onMouseOver, onClick
    } = this.props;
    let tempFunction = [];
    return (
      <div key={datas.key}
           className={`home-page-contain ${showSubTitle && 'home-page-container'}`}
           onMouseOver={() => {
             typeof onMouseOver === 'function' && onMouseOver();
           }}>
        <div className='home-page-content-title'>{datas.name}</div>
        <Row className='home-page-content-content' ref='navSingle'>
          {
            datas.data && datas.data.map((data, index) => {
              tempFunction = tempFunction.concat(data.funcList);
              if (index < 10)
                return (
                  <Col key={data.key}
                       className='navigation2'
                       xxl={12}
                       xl={24}
                       onClick={() => {
                         typeof onClick === 'function' && onClick(data)
                       }}
                  >
                    <span> {data.name}</span>
                  </Col>
                )
            })}
            <div className='clearBoth'/>
        </Row>
      </div>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/home/navigation/NavLeftSingle.js